import { createAction } from 'redux-actions';
import {
  SAVE,
  DESTROY,
  GET
} from '../action_types';

export const save         = createAction(SAVE);
export const destroy      = createAction(DESTROY);
export const get          = createAction(GET);
